import { twMerge } from "tailwind-merge"

export function cn(...args: any[]) {
  const parts = args
    .filter(Boolean)
    .map((s) => s.replaceAll(/\s+/g, " ").trim())

  return twMerge(parts.join(" "))
}
